export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nach Abschluss des Handels wird er geschlossen. Interne Mittel werden an den Benutzer überwiesen."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sind Sie sicher, dass Sie den Handel abschließen möchten?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ja, abschließen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nein, aktiv lassen"])}
}